<template>
    <div v-if="buttonInitiated && isShowButton">
        <div class="wrapper-redeem" >
            <div v-if="isDonateType">
                <div class="error-txt">
                    {{errorText()}}
                </div>
            </div>
            <div :class="[buttonType()]">
                <div
                    v-if="redeemType == 'donate'"
                    id="quantity_button">
                    <div class="btn-txt ">
                        <QuantityButton
                            v-model="itemQuantity"
                            :quantity="quantity"
                            :isCanDraw="isCanDraw"
                            @updateValue="updateValue($event)"
                        />

                    </div>
                </div>
                <div id="redeem_button" class="btn-wrapper"
                    :class="[{'disable': isButtonDisable}, buttonClass, {'disable': !isCanDraw && isDonateType}]"
                    v-if="!detailController.isLoading">
                    <div class="btn-txt"
                        v-if="isDonateType"
                        v-html="lblRedeemBTN.donate"
                        @click="clickRedeem"></div>
                    <div class="btn-txt"
                        v-else
                        v-html="buttonLbl"
                        @click="clickRedeem"></div>
                </div>
                <div class="btn-wrapper btn-disable"
                    v-if="detailController.isLoading">
                    <div class="btn-txt"
                        @click="clickRedeem">{{lblRedeemBTN.isLoading}}</div>
                </div>
            </div>

            <!-- <div class="redeem-line"></div> -->
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import QuantityButton from './QuantityButton.vue';
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * Property
 * @property {boolean} isLogin (required) Is user logged in.
 * @property {number} point (required) User available point.
 * @property {number} selectedPoint (required) Point amount for redeem campaign.
 * @property {number} selectedQuantity (required) Campaign's quantity.
 * @property {object} lblRedeemBTN (required) Text for component.
 * @property {object} campaign (required) Campaign data.
 * @property {object} redeemBTN (required) Redeem information (redeemable, isDisable etc.).
 *
 * Event
 * @event clickRedeem Callback to parent component when click redeem button.
 * Method
 * @method initialRedeemButton Setup redeem button data (text, redeemable, disable css class, etc.).
 *
 * Utilities
 * @method cleanRedeemButtonLabel Replace \n with <br/>.
 * @method getRedeemButtonClass Get redeem current css class.
 */

export default {
    name: "RedeemButton",
    props: {
        isLogin: Boolean,
        userPoint: Number,

        lblRedeemBTN: Object,
        lblModal: Object,
        detailController: Object,
        modalController: Object,
        redeemController: Object,
        redeemType: String,
    },
    components: {
        QuantityButton
    },
    computed: {
        isDonateType: function () {
            return this.redeemType == 'donate'
        },
    },
    data: function() {
        return {
            type: null,
            point: 0,
            pointType: '',
            quantity: 0,
            itemQuantity: 1,
            campaign: {},

            buttonClass: 'disable',
            buttonLbl: '',
            buttonInitiated: false,
            isAllowRedeem: false,
            isUseDefault: false,
            isShowButton: true,

            isCanDraw: true,

            totalUsePoint: null,
            myPoint: 0,

            tracking: new TrackingService(this)
        };
    },
    created: function () {
        this.type = this.detailController.type;
        this.point = this.detailController.point;
        this.pointType = this.detailController.pointType;
        this.quantity = this.detailController.quantity;
        this.campaign = this.detailController.campaign;

        if (!this.isDonateType) {
            this.buttonLbl = this.lblRedeemBTN.default;
        }
        this.isAllowRedeem = this.campaign.isConditionPass;
        this.isButtonDisable = !this.campaign.isConditionPass;

        this.myPoint = this.$store.getters.getFormatted;
    },
    mounted: function () {
        this.initialRedeemButton();
        this.buttonClass = this.getRedeemButtonClass();
        this.buttonLbl = this.cleanRedeemButtonLabel();
        this.totalUsePoint = this.detailController.point;
        if ((this.myPoint < this.detailController.point) && this.redeemType == 'donate') {
            this.isCanDraw = false;
        }
    },
    methods: {
        //Event
        updateValue: function (value) {
            let usePoint = value * this.detailController.point;
            this.totalUsePoint = usePoint;
            if (this.myPoint < usePoint) {
                this.isCanDraw = false;
            } else {
                this.isCanDraw = true;
            }
        },
        errorText: function () {
            if (!this.isCanDraw && !this.buttonLbl) {
                return this.lblRedeemBTN.not_enough_points;
            }
            return this.buttonLbl;
        },
        buttonType: function () {
            if (this.redeemType == 'donate') return 'grid-btn'
        },
        clickRedeem: function () {
            if (!this.isCanDraw) return;
            if (this.isAllowRedeem) {
                if (this.isLogin) {
                    this.$emit('setUsePoint', this.totalUsePoint);
                    this.$emit('clickRedeem');
                    let trackCamp = this.campaign.id + "|" + this.campaign.name;
                    this.tracking.event('redeem_button', 'click_redeem_button', trackCamp);
                } else {
                    this.modalController.skipModal
                        .setTitle(this.lblModal.redeem.title)
                        .setMsg(this.lblModal.redeem.msg)
                        .setBtnOk(this.lblModal.btn_confirm)
                        .setTag('skip-login')
                        .show();

                    this.modalController.skipModal.onClickOk((data) =>{
                        if(data.tag == 'skip-login'){
                        window.location.replace('/linelogin');
                        }
                    });
                    // this.modalController.alertModal
                    //     .clearText()
                    //     .setTitle(this.lblRedeemBTN.alert_headline)
                    //     .setMsg(this.lblRedeemBTN.alert_login_msg)
                    //     .setBtnOk(this.lblRedeemBTN.alert_ok_btn)
                    //     .setTag('redeem-btn')
                    //     .show();

                    // this.modalController.alertModal
                    //     .onClickOk(() => {
                    //         this.$router.push('/register');
                    //     });
                }
            }
        },
        //Function
        initialRedeemButton: function () {
            //Check is campaign supported.
            if (this.type == Vue.CampaignType.Bid ||
                this.type == Vue.CampaignType.Event ||
                this.type == Vue.CampaignType.Media) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'notsupport';
                this.buttonLbl = this.lblRedeemBTN.notSupport;

                if(this.type == Vue.CampaignType.Event){
                    this.isShowButton = false;
                }
            }

            //check published.
            if (this.campaign.statusID != 3) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'notpublish';
                this.buttonLbl = this.lblRedeemBTN.notPublish;
            }

            //Check expire date.
            if (this.campaign.currentDate > this.campaign.expireDate) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'expired';
                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
            }
            //Check sold out.
            if (this.quantity <= 0) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "soldout";
                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
            }
            //Do validate when logged in.
            if (this.isLogin) {
                //Check user enough point.
                console.log('pointType', this.pointType)
                if (this.point > this.userPoint) {
                    if (this.pointType && this.pointType != 'use') {
                        //Get point, do nothing.
                        this.isAllowRedeem = true;
                    } else {
                        this.isAllowRedeem = false;
                        this.isButtonDisable = true;
                        this.buttonClass = 'notenoughpoint';
                        if (!this.isDonateType) this.buttonLbl = this.lblRedeemBTN.notEnoughPoint;
                    }
                }

                //Handle common case for custom text.
                if (!this.campaign.isConditionPass) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    //Use api text message.
                    if (this.isUseDefault) {
                        this.buttonClass = 'condition';
                        this.buttonLbl = this.campaign.conditionAlert;
                    } else {
                        switch (this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.buttonLbl = this.lblnone;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.buttonClass = "soldout";
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.buttonClass = "maxperson";
                                this.buttonLbl = this.lblRedeemBTN.maxPerPerson;
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.buttonClass = "cooldown";
                                this.buttonLbl = this.lblRedeemBTN.redeemCoolDown;
                                break;
                            case 4:
                                //Never see this.
                                this.buttonLbl = this.lblRedeemBTN.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.buttonClass = "eligible";
                                this.buttonLbl = this.lblRedeemBTN.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.buttonClass = "expired";
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignNotAvailableBuy : this.lblRedeemBTN.campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.buttonClass = "condition";
                                this.buttonLbl = this.campaign.conditionAlert;
                                break;
                        }
                    }
                } else {
                    this.buttonClass = 'allow';

                    if (this.campaign.customCaption) {
                        this.buttonLbl = this.campaign.customCaption;
                    }else{
                        if (this.type == Vue.CampaignType.Interface) {
                            if(this.campaign.interfaceDisplay == 'surveyapprove') {
                                this.buttonLbl = this.lblRedeemBTN.review_product;
                            }else if(this.campaign.interfaceDisplay == 'survey') {
                                this.buttonLbl = this.lblRedeemBTN.survey;
                            }
                        }
                    }
                }
            } else {
                this.buttonClass = 'allow';

                if (this.campaign.customCaption) {
                    this.buttonLbl = this.campaign.customCaption;
                }else{
                    if (this.type == Vue.CampaignType.Interface) {
                        if(this.campaign.interfaceDisplay == 'surveyapprove') {
                            this.buttonLbl = this.lblRedeemBTN.review_product;
                        }else if(this.campaign.interfaceDisplay == 'survey') {
                            this.buttonLbl = this.lblRedeemBTN.survey;
                        }
                    }
                }
            }
            this.$nextTick(() => {
                this.buttonInitiated = true;
            });
        },
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.buttonLbl);
        },
        getRedeemButtonClass: function () {
            if (!this.isAllowRedeem)
                return this.buttonClass;

            return 'allow';
        }
    }

}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/input/BaseButton.scss";
.wrapper-redeem{
    width: 100%;
    height: auto;
    background-color: $white;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;

    #quantity_button {
        @include btn-wrapper(90%);
        max-width: $max-width-page;
        margin-top: 20px;
        margin-bottom: 15px;
        background: white;

    }
    .error-txt {
        display: block;
        text-align: center;
        padding-top: 10px;
        font-size: 16px;
        color: #ff0000;
    }
    #redeem_button {
        @include btn-wrapper(90%);
        max-width: $max-width-page;
        margin-top: 20px;
        margin-bottom: 15px;

        &.disable{
            background-color: $border-gray;
        }
    }

    .redeem-line{
        @include bottom-line();
        margin-bottom: 10px;
    }
}
.grid-btn {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    max-width: $max-width-page;
    margin: 0 auto;
}

</style>
